var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35303 11.9531C9.62256 11.9531 12.3296 9.24023 12.3296 5.97656C12.3296 2.70703 9.6167 0 6.34717 0C3.0835 0 0.376465 2.70703 0.376465 5.97656C0.376465 9.24023 3.08936 11.9531 6.35303 11.9531ZM3.98584 6.49219C3.64014 6.49219 3.40576 6.31055 3.40576 5.98828C3.40576 5.66016 3.62842 5.47266 3.98584 5.47266H8.72021C9.07178 5.47266 9.28857 5.66016 9.28857 5.98828C9.28857 6.31055 9.06006 6.49219 8.72021 6.49219H3.98584Z",
    fill: "#4C276A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.7317db7305781dc7f0791fe2c79458ac.svg";
export { ForwardRef as ReactComponent };